import React, { Component } from 'react'
import PrismicReact from 'prismic-reactjs'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { provinceClicked } from '../../redux/actions/gtmActions'
import htmlSerializer from '../../plugins/htmlSerializer'
import BgPattern from '../BgPattern'
import AccordionWrapper from '../AccordionWrapper'
import { Accordion } from 'react-accessible-accordion'

const propTypes = {
  slice: PropTypes.object,
  linkResolver: PropTypes.func
}

class ProvinceSection extends Component {
  handleChange = key => {
    // console.log(PrismicReact.RichText.asText(this.props.slice.items[key].province_name))
    this.props.provinceClicked(PrismicReact.RichText.asText(this.props.slice.items[key].province_name))
  }

  render() {
    let { 
      slice,
      linkResolver
    } = this.props
    const sp = slice.primary
    // console.log(slice)

    return (
      <section className="section-province">
        <BgPattern/>
        <div className="container container-medium">
          <div className="heading">
            {PrismicReact.RichText.render(sp.heading)}
          </div>
          <Accordion
            onChange={this.handleChange}
          >
            {
              slice.items.map((item, index) => (
                <AccordionWrapper 
                  key={PrismicReact.RichText.asText(item.province_name)}
                  uniqueID={index + 1}
                  question={PrismicReact.RichText.render(item.province_name, linkResolver)}
                  answer={PrismicReact.RichText.render(item.location_information, linkResolver, htmlSerializer)}
                />
              ))
            }
          </Accordion>
        </div>
      </section>
    )
  }
}

ProvinceSection.propTypes = propTypes

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    { 
      provinceClicked: provinceClicked, 
    },
    dispatch
  )

export default connect(null, mapDispatchToProps)(ProvinceSection)


// WEBPACK FOOTER //
// ./src/components/GeneralPage/ProvinceSection.js